import React from "react";
import {Message, Form, Grid, Header, Input, Button, Icon} from "semantic-ui-react";

function QuizAdder(
    {
        questionNumber,
        id,
        handleSetQuizAssignmentData,
        value
    }
) {
    return (

        value ?
            <div style={{marginTop: 10, marginRight: 5, marginLeft: 5}}>
                <div style={{border: ' 3px solid', textAlign: 'left', width: 800}}>
                    <Message attached header={`Question ${questionNumber + 1}`}
                             style={{paddingLeft: 10, paddingRight: 10}}/>
                    <Form className='attached fluid segment'>

                        <Form.Input
                            fluid
                            label='English:'
                            placeholder='English Phrase'
                            type='text'
                            name='question'
                            id={id}
                            value={value.question}
                            onChange={handleSetQuizAssignmentData}
                        />
                        <Form.Input
                            fluid
                            label='Samoan:'
                            placeholder='Samoan Phrase'
                            type='text'
                            name='answer'
                            id={id}
                            value={value.answer}
                            onChange={handleSetQuizAssignmentData}
                        />
                        {
                            value.audio ?
                                <>
                                    <Form.Input label='Sound (Optional)' type='text' value={value.audio} name='audio'
                                                id={id}
                                                onChange={handleSetQuizAssignmentData}/>

                                    <Form.Input label='Sound (Optional)' type='file' name='audio' id={id}
                                                onChange={handleSetQuizAssignmentData}/>

                                </>
                                :
                                <Form.Input label='Sound (Optional)' type='file' value={value.audio} name='audio'
                                            id={id}
                                            onChange={handleSetQuizAssignmentData}/>

                        }
                        {
                            value.picture ?
                                <>
                                    <Form.Input label='Picture (Optional)' type='text' value={value.picture}
                                                name='picture' id={id}
                                                onChange={handleSetQuizAssignmentData}/>
                                    <Form.Input label='Picture (Optional)' type='file' name='picture' id={id}
                                                onChange={handleSetQuizAssignmentData}/>
                                </>
                                :
                                <Form.Input label='Picture (Optional)' type='file' value={value.picture} name='picture'
                                            id={id}
                                            onChange={handleSetQuizAssignmentData}/>

                        }


                    </Form>
                </div>
            </div>
            :
            <div style={{marginTop: 10, marginRight: 5, marginLeft: 5}}>
                <div style={{border: ' 3px solid', textAlign: 'left', width: 800}}>
                    <Message attached header={`Question ${questionNumber + 1}`}
                             style={{paddingLeft: 10, paddingRight: 10}}/>
                    <Form className='attached fluid segment'>

                        <Form.Input
                            fluid
                            label='English:'
                            placeholder='English Phrase'
                            type='text'
                            name='question'
                            id={id}
                            onChange={handleSetQuizAssignmentData}
                        />
                        <Form.Input
                            fluid
                            label='Samoan:'
                            placeholder='Samoan Phrase'
                            type='text'
                            name='answer'
                            id={id}
                            onChange={handleSetQuizAssignmentData}
                        />
                        <Form.Group widths='equal'>
                            <Form.Input label='Sound (Optional)' type='file' name='audio' id={id}
                                        onChange={handleSetQuizAssignmentData}/>
                            <Form.Input label='Picture (Optional)' type='file' name='picture' id={id}
                                        onChange={handleSetQuizAssignmentData}/>

                        </Form.Group>


                    </Form>
                </div>
            </div>
    )
}

export default QuizAdder
